import { getDomain } from "./Utils";

export const userApiBaseUrl = `${getDomain()}/user-mgmt`;
export const vehicleApiBaseUrl = `${getDomain()}/ev`;
// export const userApiBaseUrl = process.env.REACT_APP_USER_API_BASE_URL;
// export const vehicleApiBaseUrl = process.env.REACT_APP_VEHICLE_API_BASE_URL;
export const grafanaBaseUrl = process.env.REACT_APP_GRAFANA_PROXY_BASE_URL;

export const vannaBaseUrl = process.env.REACT_APP_VANNA_APP_URL;

export const userJwtLoginUrl =
  userApiBaseUrl + process.env.REACT_APP_USER_JWT_LOGIN_URL;

export const userJwtRegisterUrl =
  userApiBaseUrl + process.env.REACT_APP_USER_JWT_REGISTER_URL;

export const existingUserDetailsUrl =
  userApiBaseUrl + process.env.REACT_APP_EXISTING_USER_URL;

export const organisationAddUserApiUrl =
  userApiBaseUrl + process.env.REACT_APP_ORGANISATION_ADD_USER_URL;

export const userJwtLoginSchemaUrl =
  userApiBaseUrl + process.env.REACT_APP_USER_JWT_LOGIN_SCHEMA_URL;

export const userJwtRegisterSchemaUrl =
  userApiBaseUrl + process.env.REACT_APP_USER_JWT_REGISTER_SCHEMA_URL;

export const vehiclePartAttributeApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_ERP_VEHICLE_PART_ATTRIBUTE_URL;

export const vehiclePartManufacturersUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_ERP_VEHICLE_MANUFACTURER_URL;

export const vehiclePartAttriburesUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_ERP_VEHICLE_ATTRIBUTE_LIST_URL;

export const vehicleModelTreeViewUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_ERP_VEHICLE_TREEVIEW_URL;

export const allVehicleDetailListApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_ERP_VEHICLE_DETAIL_LIST_URL

export const imeiListApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_IMEI_LIST_URL;

export const vehicleListApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_IDS_LIST_URL;

export const vehicleDetailsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_DETAILS_URL;

export const vehicleTestStartApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_START_URL;

export const vehicleTestHBStartApiUrl=
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_HB_START_URL;

export const vehicleTestStopApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_STOP_URL;

export const vehicleTestResultApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_RESULT_URL;

export const vehicleTestHBResultApiUrl=
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_HB_RESULT_URL;

export const vehicleAddCommentsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_ADD_COMMENTS_URL;

export const dataTableFieldsApiUrl = 
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_DATA_FIELDS_URL;

export const vehicleDataApiUrl =
 vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_DATA_URL;

export const roleListApiUrl =
  userApiBaseUrl + process.env.REACT_APP_ROLE_LIST_URL;

export const jwtConfirmUrl =
  userApiBaseUrl + process.env.REACT_APP_JWT_CONFIRM_EMAIL_URL;

export const userGenerateJwtTokenUrl =
  userApiBaseUrl + process.env.REACT_APP_USER_GENERATE_JWT_TOKEN_URL;

export const vehicleTestListUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_LIST_URL;

export const jwtResetPasswordUrl =
  userApiBaseUrl + process.env.REACT_APP_JWT_RESET_PASSWORD_URL;

export const jwtChangePasswordUrl =
  userApiBaseUrl + process.env.REACT_APP_JWT_CHANGE_PASSWORD_URL;

export const changePasswordSchemaUrl =
  userApiBaseUrl + process.env.REACT_APP_JWT_CHANGE_PASSWORD_SCHEMA_URL;

export const vehicleTripSummaryUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TRIP_SUMMARY_URL;

export const testRideFormSubmitApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_RIDE_FORM_SUBMIT_URL;

export const testRideListUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_RIDE_LIST_URL;

export const testRideFilterUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_RIDE_FILTER_URL;

export const testRideFilterCountUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_RIDE_FILTER_COUNT_URL;

export const testRideCumulativeUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TEST_RIDE_CUMULATIVE_URL;

export const vehicleModelListUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_MODEL_LIST_URL;

export const organisationInfoUrl =
  userApiBaseUrl + process.env.REACT_APP_ORGANISATION_INFO_URL;

export const citiesUrl = vehicleApiBaseUrl + process.env.REACT_APP_CITIES_URL;

export const fleetsUrl = vehicleApiBaseUrl + process.env.REACT_APP_FLEETS_URL;

export const executiveMetaDataUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_EXECUTIVE_METADATA_URL;

export const executiveSparklineDataUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_EXECUTIVE_SPARKLINE_URL;

export const executiveStackDataUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_EXECUTIVE_STACK_DATA_URL;

export const executiveImeiDataUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_EXECUTIVE_IMEI_DATA_URL;

export const organisationListApiUrl =
  userApiBaseUrl + process.env.REACT_APP_ORGANISATION_LIST_URL;

export const userSendOtpUrl =
  userApiBaseUrl + process.env.REACT_APP_JWT_SEND_OTP_URL;

export const userVerifyOtpUrl =
  userApiBaseUrl + process.env.REACT_APP_JWT_VERIFY_OTP_URL;

export const fleetBasedVehicleModelsUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_FLEET_BASED_VEHICLE_MODELS_URL;

export const exportDataMatrixUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_EXPORT_DATA_MATRIX_URL;

export const exportHistoryUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_EXPORT_HISTORY_URL;

export const exportFileStatusUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_EXPORT_FILE_STATUS_URL;

export const exportRequestUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_EXPORT_REQUEST_URL;

export const vehicleAlertsCountApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_ALERTS_COUNT_URL;

export const vehicleAlertListApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_ALERT_LIST_URL;

export const vehicleAlertDetailsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_ALERT_DETAILS_URL;

export const vehicleAlertGraphDetailsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_ALERT_GRAPH_DETAILS_URL;

export const addUserFleetsApiUrl = vehicleApiBaseUrl + process.env.REACT_APP_USER_TO_FLEETS_URL;

export const vehicleDriveModeApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_DRIVE_MODE_URL;
  
export const vehicleHeartBeatStatisticsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_HEART_BEAT_TEST_PERCENTAGE_URL;

export const vehicleDynoStatisticsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_DYNO_TEST_PERCENTAGE_URL;

export const vehicleStatusCountApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_STATUS_COUNT_URL;

export const vehicleCurrentStatusApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_CURRENT_STATUS_URL;

export const vehicleStatusListApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_STATUS_LIST_URL;

export const vehicleStatusLocationsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_STATUS_LOCATIONS_URL;

export const vehicleTopAndLeastRunningApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_RUNNING_STATS_URL;

export const fleetVehicleDetailsApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_FLEET_VEHICLE_DETAILS_URL;

export const fleetVehicleMetaDataApiUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_FLEET_VEHICLE_META_DATA_URL;
  
export const vehicleAutoTripsUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_AUTO_TRIPS_URL;

export const vehicleTravelledDistanceUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_TRAVELLED_DISTANCE_URL;

export const vehicleHealthStatusUrl =
  vehicleApiBaseUrl + process.env.REACT_APP_VEHICLE_HEALTH_STATUS_URL
